/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchErrorMsgDrugSummary,
  getRebateProgrameList,
  dispatchPerformDisputeResolutionObj,
  dispatchFrom,
  getPlanTypeValues,
  dispatchRebateProgramName,
  getCmsTypeSummary,
  getDrugCmsTypeSummary,
  getDrugTypeSummary,
  dispatchDisplayObjSummary,
} from '../store/action';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
} from '../../../../SharedModules/Errors/constantMessageData';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const DrugTypeSummary = (props) => {
  const dispatch = useDispatch();

  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.DrugSummaryReducer?.performDisputeResolutionObj
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.DrugSummaryReducer?.planType
  );
  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.DrugSummaryReducer?.rebateProgram
  );
  const getRebateProgramName = useSelector(
    (state) => state?.sharedState?.DrugSummaryReducer?.rebateProgramName
  );
  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.DrugSummaryReducer?.errorMsgDrugSummary
  );
  const getCmsList = useSelector(
    (state) => state?.sharedState?.DrugSummaryReducer?.cms
  );
  const { quarterFrom: quarterValue, selectedPlanType } = useSelector(
    (state) => state.sharedState.DrugSummaryReducer
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [radioList, setRadioList] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [quarter, setQuarter] = React.useState(quarterValue);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          quarter: '',
        }
  );
  // dispatch function
  const setPerformDisputeScrData = (value) =>
    dispatch(dispatchPerformDisputeResolutionObj(value));
  // on scroll default top level

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // handling highlight tab
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/drugTypeSummary', true);
    } else {
      tabHighLigther('/drugTypeSummary', false);
    }
  }, [getErrorMsg]);
                
  // remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgDrugSummary([]));
  }, [ planTypeList, quarter, ]);
  
  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformDisputeScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformDisputeScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    if (name === 'rebateProgramCd' && (!value || value == -1))
      localErr = [
        ...localErr,
        {
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
        },
      ];
    dispatch(dispatchErrorMsgDrugSummary([...new Set(localErr)]));
  };

  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value?.trim();
  
    localErr = localErr.filter(
      (item) =>
        item.field !== 'search' &&
        item.field !== 'manufacturerData'
    );
  
    if (type === 'rebateProgramCd') {
      setState((prev) => ({
        ...prev,
        rebateProgramCd: value,
      }));
    }
  
    if (type === 'quarter') {
      // Remove existing quarter errors
      localErr = localErr.filter(
        (item) => item.field !== 'quarter'
      );
  
      if (!data) {
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: QUARTER_VALUE_REQUIRED,
        });
      } else {
        const quarterValue = data.toUpperCase();
  
        if (
          quarterTest1.test(quarterValue) ||
          quarterTest2.test(quarterValue)
        ) {
          const formattedValue =
            autoFormateDate(quarterValue);
  
          setQuarter(formattedValue);
  
          setState((prev) => ({
            ...prev,
            quarterValue: formattedValue,
          }));
        } else {
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      }
    }
  
    dispatch(dispatchErrorMsgDrugSummary(localErr));
  };

  // on Click to next screen
  const click = () => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr = getErrorMsg || [];
    if (!quarter) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDrugSummary(unique));
    if (localErr.length == 0) {
      setSearchClicked(true);
      dispatch(
        getCmsTypeSummary({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
          paidQtr: quarter,
        })
      );
      dispatch(
        getDrugTypeSummary({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
          paidQtr: quarter,
        })
      );
      dispatch(
        getDrugCmsTypeSummary({
          rebateProgramCode: rebateProgramName?.rebateProgramCd,
        })
      );
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchFrom(quarter));
      dispatch(
        dispatchDisplayObjSummary({
          rebateProgramName,
          quarterFrom: quarter,
        })
      );
    }
  };

  if (isSearchClicked && getCmsList?.rebateCmsTypeVOList?.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayDrugTypeSummary',
      value: 'Display Drug Type Summary Report',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props?.history) {
      props.history.push({
        pathname: '/displayDrugTypeSummary',
      });
    }
    dispatch(clearReduxForFilterAndSort('/displayDrugTypeSummary'));
  }
  const handlefromChange = (event) => {
    let { value } = event.target;
    // if (value.includes('q')) {
    //   value = value.replace('q', 'Q');
    // }
    setQuarter(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'quarter');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDrugSummary(unique));
  };
  return (
    <div className="tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Summary Reports" parent2="Drug Type Summary" />
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          ),
        ]}
      />

      <div className="tab-body">
        <div className="row">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="drugType_PlanType"
              id="radio-button-for-rcdd_id"
              labelName="Plan Type"
              required
              optionList={radioList || []}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-4">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Rebate Program <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="form-wrapper p-0">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    className="mandate-fields"
                    data-testid="rebate_program-ia"
                    id="rebate_program"
                    label="rebate_program"
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={state && state.rebateProgramCd}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    helperText={
                      getErrorMsg?.length > 0
                        ? [
                            ...new Set(
                              getErrorMsg
                                ?.filter((x) => {
                                  return x.field === 'rebateProgramCd';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      getErrorMsg?.length > 0 &&
                      getErrorMsg?.filter((x) => {
                        return x.field === 'rebateProgramCd';
                      }).length > 0
                        ? [
                            ...new Set(
                              getErrorMsg
                                ?.filter((x) => {
                                  return x.field === 'rebateProgramCd';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-4">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Quarter <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="form-wrapper p-0">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    id="check_by_invoice_quater"
                    label="check_by_invoice_quater"
                    data-testid="drugTypeSum-qtr"
                    required
                    fullWidth
                    value={quarter}
                    onChange={handlefromChange}
                    placeholder=""
                    inputProps={{ maxLength: 6 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field == 'quarter' ? 'mandate-fields' : null
                          )
                        : null
                    }
                    onBlur={(e) => handleOnblurEvent('quarter', e.target.value)}
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'quarter' ? l.message : null
                          )
                        : null
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field == 'quarter' ? l.message : null
                          )
                        : null
                    }
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>

      <div className="col-sm-12">
        <div className="btn-wrapper mb-2">
          <div className="float-right mt-2 hide-on-print">
            <Button
              className="btn btn-success btn-search"
              data-testid="view_detail_ia"
              type="button"
              onClick={click}
            >
              {' '}
              <SVGComponent iconName="Icon-search" /> {'  '} Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrugTypeSummary;
